import { Navigate } from 'react-router-dom';
import useFeature from '@/contexts/FeatureFlags/useFeature';
import useFeatureFlags from '@/contexts/FeatureFlags/useFeatureFlags';

/**
 * המסך שקרן נפתחת עליו, כשנכנסים לאתר או לכתובת של הקרן בלי מסך.
 *
 * SPR-10303 (מרכז הצדקה): "שנכנסים לאתר שהוא יפתח על טאב תמונת מצב ולא על לוח תנועות".
 * מי שתמונת מצב פתוחה לו (דגל 'dashboard') נוחת עליה, וכל השאר על לוח התנועות כמקודם.
 * כך הפתיחה נפתחת יחד עם המסך, מאותו מסך ניהול הדגלים ובלי פריסה.
 *
 * עד שמפת הדגלים של הקרן חוזרת לא מפנים לשום מקום: הפניה מוקדמת הייתה נוחתת
 * על התנועות, מושכת אותן, וקופצת שנייה אחר כך. דגלים שנכשלו בטעינה נקראים כסגורים,
 * והרכז נוחת על לוח התנועות.
 */
const FundHomeRedirect = () => {
  const dashboardOn = useFeature('dashboard');
  const { isLoading } = useFeatureFlags();

  if (isLoading) return null;
  return <Navigate to={dashboardOn ? 'dashboard' : 'transactions'} replace />;
};

export default FundHomeRedirect;
